//  标签搜索

import React from 'react';
import { Input, InputGroup } from 'rsuite';
import moment from 'moment';

import Cache from '../frame/Cache';
import Config from '../config/Config';
import Widget from '../widget/Widget';

import WidgetAjax from '../widget/WidgetAjax';
import WidgetSelect from '../widget/WidgetSelect';
import WidgetMessage from '../widget/WidgetMessage';
import WidgetComponent from '../widget/WidgetComponent';
import WidgetCondition from '../widget/WidgetCondition';
import WidgetPageTable from '../widget/WidgetPageTable';
import WidgetDrawer from '../widget/WidgetDrawer';
import AttributeSearch from './search/AttributeSearch';

import EntityDetail from './EntityDetail';

import '../css/analysis.css';
import '../css/tag.css';

class EnterpriseSearch extends WidgetComponent 
{
    constructor(props) 
    {
        super(props);

        const url = Config.getBasePath();
        const OBJECTTYPE = Config.getOBJECTTYPE();

        this.state = {
            basePath: Config.getBasePath(),
            url: url,
            OBJECTTYPE: OBJECTTYPE,
            conditions: {},     // 存储条件筛选的信息
            attributes: [],
            columns: [
                [
                    { name: 'ENTID', title: 'ENTID', type: 'string', description: '主体ID', properties: { hidden: true } },
                ],
                [
                    { name: 'MONITOR', title: 'MONITOR', type: 'string', description: '监控状态', properties: { hidden: true } },
                    { name: 'ENTNAME', type: 'string', description: '市场主体名称', properties: { hidden: false, click: "entityDetail" } },
                    { name: 'REGSTATE', type: 'string', description: '企业状态', properties: { hidden: false } },
                ],
                [
                    { name: 'TAGS', type: 'string', description: '主体标签', properties: { hidden: false, type: "label" } }
                ],
                [
                    { name: 'DOM', title: '经营地址', type: 'string', description: '经营地址', properties: { hidden: false } },
                    { name: 'INDUSTRYPHY', title: '行业类型', type: 'string', description: '行业类型', properties: { hidden: false } },
                    { name: 'REGCAP', title: '注册资本', type: 'string', description: '注册资本', properties: { hidden: false, unit:"万元" } },
                    { name: 'ESTDATE', title: '成立时间', type: 'string', description: '成立时间', properties: { hidden: false } }
                ],
                [
                    { name: 'TEL', title: '联系方式', type: 'string', description: '联系方式', properties: { hidden: false, transform: "transformTEL"} },
                ],
                [
                    {
                        name: 'operation', type: 'string', description: '操作', properties: {
                            operations: [
                                { name: '添加监控', click: "addMonitor" },
                                { name: '取消监控', click: "removeMonitor" },

                                { name: '添加CRM', click: "addCRM" },
                                { name: '取消CRM', click: "removeCRM" },

                                // { name: '添加种子企业', click: "addFavor"},
                                // { name: '取消种子企业', click: "removeFavor"},
                            ],
                            transform: "transformOperations"
                        }
                    }
                ]
            ],
            data: undefined,
            checkedKeys:[],
            isBatch: false,
            loading: true,
            total: undefined,
            tableOptions: {
                records: 10,
                rowKey: "ENTID",
                isAutoHeight: true,
                checkedKey: "ENTID",
                keyWordColumnName:"ENTNAME",
                check: true,
            },
            messageOptions: {
                title: '添加监管'
            },
            detailData: undefined,
            drawerOptions: {
                size: 'lg',
                button: false,
            },
            checkData: [],
            checkDataLength: 0,
            selectOptions: {
                title : "批量选择",
                cleanable : true
            },
            selectData : [
                {label:"批量选择", value:99},
                {label:"前10条记录", value:1},
                {label:"前20条记录", value:2},
                {label:"前50条记录", value:3},
                {label:"前100条记录", value:4},
                {label:"全部记录", value:5},
            ],
            bacthTypeValue:99,
            flag:false,
        };

        this.bindConsole(url);

        this.readCondition = this.readCondition.bind(this);
        this.onReadCondition = this.onReadCondition.bind(this);

        this.buildFilter = this.buildFilter.bind(this);

        this.search = this.search.bind(this);
        this.onSearch = this.onSearch.bind(this);

        this.pageTurning = this.pageTurning.bind(this);
        this.tableOnEvent = this.tableOnEvent.bind(this);

        this.transformTEL = this.transformTEL.bind(this);
        this.transformOperations = this.transformOperations.bind(this);

        this.addMonitor = this.addMonitor.bind(this);
        this.addMonitorConfirm = this.addMonitorConfirm.bind(this);
        this.onAddMonitor = this.onAddMonitor.bind(this);

        this.removeFavor = this.removeFavor.bind(this);
        this.removeFavorConfirm = this.removeFavorConfirm.bind(this);
        this.onRemoveFavor = this.onRemoveFavor.bind(this);

        this.removeMonitor = this.removeMonitor.bind(this);
        this.removeMonitorConfirm = this.removeMonitorConfirm.bind(this);
        this.onRemoveMonitor = this.onRemoveMonitor.bind(this);

        this.addFavor = this.addFavor.bind(this);
        this.addFavorConfirm = this.addFavorConfirm.bind(this);
        this.onAddFavor = this.onAddFavor.bind(this);

        this.addCRM = this.addCRM.bind(this);
        this.addCRMConfirm = this.addCRMConfirm.bind(this);
        this.onAddCRM = this.onAddCRM.bind(this);

        this.removeCRM = this.removeCRM.bind(this);
        this.removeCRMConfirm = this.removeCRMConfirm.bind(this);
        this.onRemoveCRM = this.onRemoveCRM.bind(this);

        this.attributeOnChange = this.attributeOnChange.bind(this);
        this.tableOnCheck = this.tableOnCheck.bind(this);

        this.addMonitors = this.addMonitors.bind(this)

        this.addCRMs = this.addCRMs.bind(this)

        this.export = this.export.bind(this);
        this.exportConfirm = this.exportConfirm.bind(this);
        this.onExport = this.onExport.bind(this);   

        this.cleanCondition = this.cleanCondition.bind(this);

        this.bacthTypeValueOnChange = this.bacthTypeValueOnChange.bind(this);

        // this.setScroll = this.setScroll.bind(this);
        
    }

    componentDidMount() {
        // 读取条件筛选
        this.readCondition();

    }

    drawerRef = (ref) => {
        this.drawerRef = ref;
    }

    setMessageRef = (ref) => {
        this.messageRef = ref;
    }

    onRefer = (ref) => {

        if (ref.props.options.name === "detail") 
        {
            this.detailModel = ref;
        }
    }

    /**
     * 查询数据
     * @param {*} page 
     */
    search(page) 
    {
        let { tableOptions, basePath } = this.state;

        let filters = this.buildFilter();

        if (page === undefined || page === null || page === "") 
        {
            page = 1;
        }

        let params = {
            schema: "T001001",
            page: page,
            records: tableOptions.records,
            filters: filters
        }

        sessionStorage.setItem('page', page);

        WidgetAjax.ajax({ url: basePath + '/report/data', params: params, callback: this.onSearch });

        this.setState({ loading: true, page: page });
    }

    onSearch(result, params) 
    {
        if (result.status === 0) 
        {
            this.setState({ data: result.results, total: result.total, loading: false });
        }
        else if (result.status === 10)
        {
            Cache.logout(this.props)
        }
        else
        {
            this.setState({ data: [], total: 0, loading: false });
        }
    }

    /**
     * 清空条件
     */
    cleanCondition() 
    {
        this.setState({ conditions:{}, flag:true });
    }

    //  读取 条件查询条件
    readCondition() 
    {
        let { url, OBJECTTYPE } = this.state;

        WidgetAjax.ajax({ url: url + '/search/attribute', params: { database_code:"BASE" }, callback: this.onReadCondition });
    }

    onReadCondition(result) 
    {
        if (result.status === 0) 
        {
            const { page } = this.state;

            this.setState({ attributes: result.results });

            this.search(page);
        }
    }

    /**
     * 属性条件变化回调函数
     * @param {*} conditions 
     */
    attributeOnChange(conditions) 
    {
        this.setState({ conditions: conditions });
    }

    /**
     * 构建 filter
     */
    buildFilter() 
    {
        let { attributes, conditions } = this.state, filters = {};

        const widgetCondition = new WidgetCondition();

        if (attributes !== undefined && attributes !== null && attributes.length > 0) 
        {
            for ( let attribute of attributes ) 
            {
                let expression, key = attribute.name;

                if (attribute.type === "DIMENSION") 
                {
                    key = attribute.content.code;
                }

                if (conditions[key] !== undefined && conditions[key] !== null)
                {
                    switch (attribute.type) 
                    {
                        case "STRING":
                        {
                            if (attribute.index === "TEXT") {
                                expression = "${" + key + "} has '" + conditions[key] + "'";
                            }
                            else {
                                expression = "${" + key + "} = '" + conditions[key] + "'";
                            }

                            filters[key] = expression;
                            break;
                        }
                        case "DATE":
                        case "NUMBER":
                        case "INTEGER":
                        {
                            if (key === "ESTDATE") 
                            {
                                if (conditions[key].start !== undefined && conditions[key].start !== "")
                                 {
                                    let startValue = moment(moment(conditions[key].start, 'YYYYMMDD')).format('YYYY-MM-DD');

                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        let endValue = moment(moment(conditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');

                                        expression = widgetCondition.createCondition(key, "range",
                                            { min: { code: key, operator: 'BE', value: startValue }, max: { code: key, operator: 'SE', value: endValue } });
                                    }
                                    else 
                                    {
                                        expression = '${' + key + '} >= ' + conditions[key].start;
                                    }
                                }
                                else 
                                {
                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        let endValue = moment(moment(conditions[key].end, 'YYYYMMDD')).format('YYYY-MM-DD');

                                        expression = '${' + key + '} <= ' + endValue;
                                    }
                                    else 
                                    {
                                        expression = undefined;
                                    }
                                }
                            }
                            else 
                            {
                                if (conditions[key].start !== undefined && conditions[key].start !== "") 
                                {
                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        expression = widgetCondition.createCondition(key, "range",
                                            { min: { code: key, operator: 'BE', value: conditions[key].start }, max: { code: key, operator: 'SE', value: conditions[key].end } });
                                    }
                                    else 
                                    {
                                        expression = '${' + key + '} >= ' + conditions[key].start;
                                    }
                                }
                                else 
                                {
                                    if (conditions[key].end !== undefined && conditions[key].end !== "") 
                                    {
                                        expression = '${' + key + '} <= ' + conditions[key].end;
                                    }
                                    else 
                                    {
                                        expression = undefined;
                                    }
                                }
                            }

                            filters[key] = expression;

                            break;
                        }
                        case "NOMINAL":
                        {
                            if (conditions[key] !== undefined) 
                            {
                                let expression = widgetCondition.createCondition(key, "point", { code: key, operator: "E", value: conditions[key] });

                                filters[key] = expression;
                            }
                            else 
                            {
                                filters[key] = undefined;
                            }
                            break;
                        }
                        case "DIMENSION":
                        {

                            key = attribute.content.code;

                            if (attribute.index === "SINGLE") 
                            {
                                if (conditions[key] !== undefined && conditions[key] !== null) 
                                {
                                    let item = conditions[key];

                                    let code = attribute.content.code;

                                    expression = widgetCondition.createCondition(item.code, "point", { code: item.code, operator: "E", value: item.value });

                                    filters[code] = expression;

                                }
                            }
                            else 
                            {
                                if (conditions[key] !== undefined && conditions[key] !== null) 
                                {
                                    let treeConditions = conditions[key], params = [];

                                    for (let code in treeConditions) 
                                    {
                                        let set = [];
                                        for (let item of treeConditions[code]) 
                                        {
                                            set.push(item.value);
                                        }
                                        params.push({ code: code, operator: 'IN', set: set });
                                    }

                                    if (params.length > 0) 
                                    {
                                        expression = widgetCondition.createCondition(attribute.content.code, "composite", params);
                                    }

                                    filters[attribute.content.code.substring(0, 4)] = expression;

                                }
                            }
                        }
                    }
                }
            }
        }


        return filters;
    }


    /**
     * 表格翻页
     * @param {*}} page 
     */
    pageTurning(page) 
    {
        this.search(page);
    }

    /**
     * 表格事件函数
     * @param {*} type 
     * @param {*} data 
     * @param {*} value 
     * @param {*} event 
     * @returns 
     */
    tableOnEvent(type, data, value, event) 
    {
        switch (type) 
        {
            case "transformTEL":
            {
                data = JSON.parse(data);

                return this.transformTEL(data, value);
            }
            case "entityDetail":
            {
                data = JSON.parse(data);

                this.setState({ detailData: data });
                this.drawerRef.open();

                break;
            }
            case "addMonitor":
            {
                data = JSON.parse(data);

                this.addMonitor(data);

                break;
            }
            case "removeMonitor":
            {
                data = JSON.parse(data);

                this.removeMonitor(data);

                break;
            }
            case "addFavor":
            {
                data = JSON.parse(data);

                this.addFavor(data);

                break;
            }
            case "removeFavor":
            {
                data = JSON.parse(data);

                this.removeFavor(data);

                break;
            }
            case "addCRM":
            {
                data = JSON.parse(data);
                this.addCRM(data);
                break;
            }
            case "removeCRM":
            {
                data = JSON.parse(data);
                this.removeCRM(data);
                break;
            }
            case "transformOperations":
            {
                return this.transformOperations(data, value);
            }
            default:
                break;
        }
    }

    /**
     * 联系方式转换
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformTEL( data, content )
    {
        if( data.TEL!==undefined && data.TEL!==null && data.TEL.length>0 )
        {
            let value = "", isFirst = true;
            for( let item of data.TEL )
            {
                if( isFirst )
                {
                    value = `<label className='tel'>`+item.tel+`</label>`;
                    isFirst = false;
                }
                else
                {
                    value += `<label className='tel'>`+item.tel+`</label>`;
                }
            }

            return value;
        }
    }

    /**
     * 操作格式化
     * @param {*} data 
     * @param {*} content 
     * @returns 
     */
    transformOperations(data, content) 
    {
        if (content.props !== undefined && content.props.children !== undefined) 
        {
            for (let i = 0; i < content.props.children.length; i++) 
            {

                // { name: '添加监控', click: "addMonitor"}, 
                // { name: '取消监控',  click: "removeMonitor"},

                // { name: '添加CRM', click: "addCRM"},
                // { name: '取消CRM', click: "removeCRM"},

                // { name: '添加种子企业', click: "addFavor"},
                // { name: '取消种子企业', click: "removeFavor"},

                let child = content.props.children[i];

                if (child.props.className === "addMonitor") 
                {
                    if (data.MONITOR === true) {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeMonitor") 
                {
                    if (data.MONITOR !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "addCRM") 
                {
                    if (data.CRM === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeCRM") 
                {
                    if (data.CRM !== true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "addFavor") 
                {
                    if (data.FAVOR === true) 
                    {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
                else if (child.props.className === "removeFavor") 
                {
                    if (data.FAVOR !== true)
                     {
                        content.props.children.splice(i, 1);
                        i--;
                    }
                }
            }
        }

        return content;
    }

    /**
     * 表格多选函数
     * @param {*} data 
     */
    tableOnCheck(data) 
    {
        this.state["checkData"] = data;

        this.setState({ checkData:data, checkDataLength: data.length });
    }

    /**
     * 添加监管
     * @param {*} data 
     */
    addMonitor(data) 
    {

        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.addMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加到监管对象中吗?`;

        messageOptions["title"] = "添加监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();

    }

    addMonitors() 
    {

        let { messageOptions, checkData } = this.state, ENTNAMEs = "", isFirst = true;

        messageOptions["isMessage"] = false;

        if( !checkData.length ) 
        {
            messageOptions["isMessage"] = true;

            messageOptions["message"] = `请选择需要添加监控的企业`;

            messageOptions["title"] = "添加监控企业";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else 
        {
            for (let item of checkData) 
            {
                if (isFirst === true) 
                {
                    ENTNAMEs = `'` + item.ENTNAME + `'`

                    isFirst = false;
                }
                else 
                {
                    ENTNAMEs += `, '` + item.ENTNAME + `'`
                }
            }

            messageOptions["message"] = `确定要把 '` + ENTNAMEs + `' 加入监控对象吗?`;

            messageOptions['confirmFunction'] = this.addMonitorConfirm;

            messageOptions["title"] = "添加监控";

            this.state['isBatch'] = true;
            this.state['entityData'] = undefined;
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    addMonitorConfirm() 
    {
        const { basePath, entityData, isBatch, checkData } = this.state;

        let params = {};

        if (isBatch === true)
         {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params["ENTIDs"] = ENTIDs;
        }
        else 
        {
            params["ENTID"] = entityData.ENTID;
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/add_entity', params: params, callback: this.onAddMonitor, backParam: { data: entityData } });
    }

    onAddMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            let { messageOptions, isBatch, checkData } = this.state;

            messageOptions["isMessage"] = true;

            if (isBatch === true) 
            {
                let ENTNAMEs = "", isFirst = true;

                for (let item of checkData) 
                {
                    if (isFirst === true) 
                    {
                        ENTNAMEs = `'` + item.ENTNAME + `'`

                        isFirst = false;
                    }
                    else 
                    {
                        ENTNAMEs += `, '` + item.ENTNAME + `'`
                    }
                }

                if (result.result === checkData.length) 
                {
                    messageOptions["message"] = ENTNAMEs + `' 全部成功加入监控对象中！`;
                    setTimeout(() => { this.props.history.go() }, 1500)
                }
                else 
                {
                    messageOptions["message"] = ENTNAMEs + `' 中有 ` + result.result + ` 条成功添加监控, 有 ` + (checkData.length - result.result) + ` 条失败!`;
                    setTimeout(() => { this.props.history.go() }, 1500)
                }
            }
            else 
            {
                messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添加进监控对象中！`;
                this.search(1);
            }

            messageOptions["title"] = "添加监控";

            this.state['entityData'] = undefined;
            this.state['checkData'] = [];
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }

    }


    /**
     * 取消监管
     * @param {*} data 
     */
    removeMonitor(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.removeMonitorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 从监管对象中移除吗?`;

        messageOptions["title"] = "取消监管";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();
    }

    removeMonitorConfirm() 
    {
        const { basePath, entityData } = this.state;

        let params = {
            ENTID: entityData.ENTID
        }

        WidgetAjax.ajax({ url: basePath + '/monitor/remove_entity', params: params, callback: this.onRemoveMonitor, backParam: { data: entityData } });
    }

    onRemoveMonitor(result, params, backParam) 
    {
        if (result.status === 0) 
        {

            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;

            messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添从监管对象中移除！`;

            messageOptions["title"] = "取消监管";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            this.state['entityData'] = undefined;

            this.search(1);
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 添加 CRM
     * @param {*} data 
     */
    addCRM(data) 
    {
        let { messageOptions } = this.state;
        messageOptions["isMessage"] = false;
        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加至CRM中吗?`;
        messageOptions['confirmFunction'] = this.addCRMConfirm;
        messageOptions["title"] = "添加CRM";
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    /**
     * 将选中的企业添加进CRM
     */
    addCRMs() 
    {
        let { checkData, messageOptions } = this.state

        if (!checkData.length) 
        {
            messageOptions["isMessage"] = true;

            messageOptions["message"] = `请选择要添加CRM的企业`;

            messageOptions["title"] = "添加CRM";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else 
        {
            let Objs, isFirst = true;

            for (let item of checkData) 
            {
                if (isFirst)
                {
                    Objs = item.ENTNAME;

                    isFirst = false;
                }
                else 
                {
                    Objs += ", " + item.ENTNAME;
                }
            }

            messageOptions["isMessage"] = false;

            messageOptions['confirmFunction'] = this.addCRMConfirm;

            messageOptions['message'] = `您确定要将 ${Objs} 加入CRM吗?`;

            this.state['messageOptions'] = messageOptions;

            this.state["isBatch"] = true

            this.messageRef.open();
        }
    }

    addCRMConfirm() 
    {
        let { messageOptions, basePath, isBatch, checkData } = this.state, params;

        if (isBatch === true) 
        {
            let ENTIDs = [];

            for (let item of checkData) 
            {
                ENTIDs.push(item.ENTID);
            }

            params = {
                "ENTIDs": ENTIDs
            }

            WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { checkData } });
        }
        else 
        {
            let data = messageOptions["entData"];

            params = {
                "ENTID": data["ENTID"]
            };

            WidgetAjax.ajax({ url: basePath + '/follow/add_entity', params: params, callback: this.onAddCRM, backParam: { Name: data.ENTNAME } });
        }
    }

    onAddCRM(result, params, backParam) 
    {
        if (result.status === 0) 
        {
            if (backParam.checkData) 
            {
                let { messageOptions } = this.state, isFirst = true, addCRMName = '';

                messageOptions["isMessage"] = true;

                for (let item in backParam.checkData) 
                {
                    if (isFirst) 
                    {
                        addCRMName = backParam.checkData[item].ENTNAME
                        isFirst = false
                    }
                    else 
                    {
                        addCRMName += ", " + backParam.checkData[item].ENTNAME
                    }
                }
                
                messageOptions["message"] = `已将 ${addCRMName} 添加至CRM!`;
                messageOptions["title"] = "添加成功";
                this.state['messageOptions'] = messageOptions;
            }
            else 
            {
                let { messageOptions } = this.state;
                messageOptions["isMessage"] = true;
                messageOptions["message"] = `已将 ${backParam.Name} 添加至CRM!`;
                messageOptions["title"] = "添加成功";
                this.state['messageOptions'] = messageOptions;
            }

            this.messageRef.open();
        }
        else if (result === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === -1) 
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！`;
            messageOptions["title"] = "错误";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }

        this.state["isBatch"] = false
    }


    /**
     * 取消 CRM
     * @param {*} data 
     */
    removeCRM(data) 
    {
        let { messageOptions, checkData } = this.state;

        messageOptions["isMessage"] = false;
        messageOptions["message"] = `确定要将 '` + data.ENTNAME + `' 从CRM中移除吗?`;
        messageOptions['confirmFunction'] = this.removeCRMConfirm;
        messageOptions["title"] = "移出CRM";
        messageOptions["entData"] = data

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    removeCRMConfirm() 
    {
        let { messageOptions, basePath } = this.state;
            
        let data = messageOptions["entData"];
        
        let params = {
                "ENTID": data.ENTID
            };
        
        WidgetAjax.ajax({ url: basePath + '/follow/remove_entity', params: params, callback: this.onRemoveCRM, backParam: { Name: data.ENTNAME } });
    }

    onRemoveCRM(result, params, backParam) 
    {

        if (result.status === 0) 
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `已将 ${backParam.Name} 从CRM中移除!`;
            messageOptions["title"] = "移除成功";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
        else if (result === 10) 
        {
            Cache.logout(this.props);
        }
        else if (result.status === -1) 
        {
            let { messageOptions } = this.state;
            messageOptions["isMessage"] = true;
            messageOptions["message"] = `发生错误，添加失败！`;
            messageOptions["title"] = "错误";
            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }

    /**
     * 添加收藏
     * @param {*} data 
     */
    addFavor(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.addFavorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 添加到收藏对象中吗?`;

        messageOptions["title"] = "添加收藏";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();
    }

    addFavorConfirm() 
    {
        const { basePath, entityData } = this.state;

        let params = 
        {
            ENTID: entityData.ENTID,
        }

        WidgetAjax.ajax({ url: basePath + '/favor/add_object', params: params, callback: this.onAddFavor, backParam: { data: entityData } });
    }

    onAddFavor(result, params, backParam) 
    {
        if (result.status === 0) 
        {

            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;

            messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功添加到收藏对象中！`;

            messageOptions["title"] = "添加收藏";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            this.search(1);

            this.state['entityData'] = undefined;
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 取消收藏
     * @param {*} data 
     */
    removeFavor(data) 
    {
        let { messageOptions } = this.state;

        messageOptions["isMessage"] = false;

        messageOptions['confirmFunction'] = this.removeFavorConfirm;

        messageOptions["message"] = `确定要把 '` + data.ENTNAME + `' 从收藏对象中移出吗?`;

        messageOptions["title"] = "取消收藏";

        this.state['messageOptions'] = messageOptions;

        this.state['entityData'] = data;

        this.messageRef.open();
    }

    removeFavorConfirm() 
    {
        const { basePath, entityData } = this.state;

        let params = {
            OBJTYPE: 1,
            OBJID: entityData.OBJID,
        }

        WidgetAjax.ajax({ url: basePath + '/favor/remove_object', params: params, callback: this.onRemoveFavor, backParam: { data: entityData } });
    }

    onRemoveFavor(result, params, backParam) 
    {
        if (result.status === 0) 
        {

            let { messageOptions } = this.state;

            messageOptions["isMessage"] = true;

            messageOptions["message"] = backParam["data"].ENTNAME + `' 已成功从收藏对象中移出！`;

            messageOptions["title"] = "取消收藏";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();

            this.search(1);

            this.state['entityData'] = undefined;
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    /**
     * 批量操作选择
     * @param {*} value 
     * @param {*} item 
     * @param {*} event 
     */
    bacthTypeValueOnChange(value, item, event)
    {
        const { data } = this.state;

        let checkedKeys = [];


        if( value!==null && value!==99 )
        {
            for( let item of data )
            {
                checkedKeys.push(item.ENTID);
            }
        }
        else
        {
            value = 99;
        }
        
        this.setState({type:value, bacthTypeValue:value, checkedKeys:checkedKeys});
    }

    /**
    * 导出按钮
    */
    export( type ) 
    {
        let { messageOptions, total, checkData } = this.state;

        messageOptions["isMessage"] = false;

        // type = "1";

        // if ( type==="1" ) 
        // {
        //     if( checkData === undefined || checkData === null || checkData.length===0 ) 
        //     {
        //         messageOptions["isMessage"] = true;

        //         messageOptions["message"] = `没有选中的记录?`;

        //         messageOptions["title"] = "导出";

        //     }
        //     else 
        //     {
        //         messageOptions["message"] = `确定要导出当前选中的记录吗?`;
        //     }
        // }
        // else if (type === "2") 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的前20条记录吗?`;
        // }
        // else if (type === "3") 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的前50条记录吗?`;
        // }
        // else if (type === "4") 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的前100条记录吗?`;
        // }
        // else 
        // {
        //     messageOptions["message"] = `确定要选中符合当前条件的全部记录吗?`;
        // }

        if( checkData!==undefined && checkData!==null && checkData.length>0 )
        {
            messageOptions["message"] = `确定要导出当前选中的 ` + checkData.length + ` 记录吗?`;
        }
        else
        {
            messageOptions["message"] = `确定要导出符合条件的全部记录吗?`;
        }

        messageOptions['confirmFunction'] = this.exportConfirm;

        messageOptions["title"] = "选中确认";

        this.state['messageOptions'] = messageOptions;

        this.messageRef.open();
    }

    exportConfirm() 
    {
        const { basePath, checkData } = this.state;
        
        let filters = {}, schema = "T001001", sorts = {};

        if (checkData !== undefined && checkData.length > 0) 
        {
            let isFirst = true, content = "";

            for (let item of checkData) 
            {
                if (isFirst) 
                {
                    content = "'" + item.ENTID + "'";
                    isFirst = false;
                }
                else 
                {
                    content += ",'" + item.ENTID + "'";
                }

            }

            filters["ENTID"] = "${ENTID} IN (" + content + ")";
        }
        else
        {
            filters = this.buildFilter();
        }

        let params = {
            schema: schema,
            filters: filters
        }

        WidgetAjax.ajax({ url: basePath + '/report/excel', params: params, callback: this.onExport });
    }

    onExport(result, params) 
    {
        const { basePath, messageOptions } = this.state;

        let fileName = "export.xlsx";

        if (result.status === 0) 
        {
            let token = result.token;

            let url = basePath + "/report/download";

            WidgetAjax.exportFile({ url: url, params: { token: token, fileName: fileName } });

            // Widget.exportFile(url);
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props.parentProps);
        }
        else 
        {
            messageOptions["isMessage"] = true;

            messageOptions["message"] = '数据导出失败！';

            messageOptions["title"] = "数据导出";

            this.state['messageOptions'] = messageOptions;

            this.messageRef.open();
        }
    }
    // setScroll(e){
    //     let height = this.refs.head.firstChild.firstChild.lastChild.offsetTop;
        

    //     if(e.target.scrollTop>=height){
    //         [...this.refs.head.firstChild.firstChild.lastChild.children][3].firstChild.firstChild.style.cssText='position:fixed;top:0;';
    //         [...this.refs.head.firstChild.firstChild.lastChild.children][4].firstChild.firstChild.style.cssText='position:fixed;top:0;'
    //     }else{
    //         [...this.refs.head.firstChild.firstChild.lastChild.children][3].firstChild.firstChild.style.cssText='position:null;';
    //         [...this.refs.head.firstChild.firstChild.lastChild.children][4].firstChild.firstChild.style.cssText='position:null;'
    //     }
    // }

    render() 
    {
        const { page, attributes, conditions, columns, data, checkedKeys, tableOptions, total, loading, messageOptions, drawerOptions, detailData, checkDataLength,flag } = this.state
       // selectOptions, selectData, bacthTypeValue 

        return (
            <div className="page search-tag-wrap page-overflow">
                <div className="page-content page-tag-content" style={{ background: 'none' }}>
                    <div className="content-top padding-bottom-16" >
                        <div id="contentTagDetail" className="content-canvas content-top-tag search-wrap enterprise-search" style={{ height: "auto", display: "table",padding:"0 0 16px 0"  }}>
                            <div className="content-tag">
                                <div id="details" className='content-tag-left content-tag-all'>
                                    <div className="search-condition" style={{ borderRadius:"8px"}}>
                                        <AttributeSearch notify={this.attributeOnChange} values={conditions} attributes={attributes} flag={flag}></AttributeSearch>
                                    </div>
                                    <div className="condition-button" style={{ textAlign: 'center' }}>
                                        <label className="determine-label" onClick={() => { this.search(undefined) }}>查询</label>
                                        <label  onClick={() => { this.cleanCondition() }}>清空</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-title Addroles2" style={{ height: "60px", paddingRight:"36px", background:"#ffffff"}}>
                        <div className='search-left'>
                            <p>为您找到 <span className='num'>{total}</span> 家企业</p>
                            {/* <div>
                                <WidgetSelect data={selectData} options={selectOptions} 
                                    onSelect={(value, itemData, e) => { this.bacthTypeValueOnChange(value, itemData, e)}} defaultValue={bacthTypeValue}/>
                            </div> */}
                        </div>
                        <div className="monitoring ">
                            <span className="selectedB">已选择 <span className="selectedBM">{checkDataLength}</span></span>
                            <button className="export-button" onClick={this.export}><img className="export" src={require("../img/exportData.svg")}  />导出数据</button>
                            <div className="addButton click" onClick={() => { this.addMonitors() }}>
                                <span>添加监控</span>
                            </div>
                            <div className="closeCRMButton" onClick={() => { this.addCRMs(2) }}>
                                <span>添加CRM</span>
                            </div>
                            {/* <div className="remove-button horizontal-middle click" onClick={()=>{this.delete(3)}}>
                                    <span >删除种子用户</span>
                                </div> */}
                        </div>
                    </div>
                    <div className="content-bottom">
                        <div id="contentTagReport" className="content-report content-canvas content-bottom-frame">
                            <div className="content-report" style={{ minHeight: 160 }}>
                                <WidgetPageTable options={tableOptions} columns={columns} data={data} total={total} loading={loading} checkedKeys={checkedKeys}
                                    notify={this.tableOnEvent} onCheck={this.tableOnCheck} pageTurning={this.pageTurning} page={page} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className="scroll" onScroll={(e)=>this.setScroll(e)}> */}
                    <WidgetDrawer options={drawerOptions} onRef={this.drawerRef} >
                        <div className="frame-body" >
                            <EntityDetail data={detailData} search={this.search} attributes={attributes}></EntityDetail>
                        </div>
                    </WidgetDrawer>
                {/* </div> */}

                <WidgetMessage options={messageOptions} onRef={this.setMessageRef} />
                
            </div>
        )
    }
}

export default EnterpriseSearch;